module.exports = __webpack_public_path__ + "static/media/Vandar.98cdbf9b.svg";